"use client";

import React from "react";
import { MessageItem } from "./MessageItem";
import type { Message } from "@/types";
import { Bot } from "lucide-react";

interface MessageListProps {
  messages: Message[];
  isTyping?: boolean;
}

export function MessageList({ messages, isTyping = false }: MessageListProps) {
  return (
    <div className="space-y-6">
      {messages.map((message) => (
        <MessageItem key={message.id} message={message} />
      ))}

      {/* Typing Indicator */}
      {isTyping && (
        <div className="flex items-start gap-3 md:gap-4">
          <div
            className="w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center shrink-0 shadow-lg"
            style={{ backgroundColor: "#0b015d" }}
          >
            <Bot className="w-4 h-4 md:w-5 md:h-5 text-white" />
          </div>
          <div className="bg-white border border-gray-200 rounded-2xl px-4 py-3 shadow-sm">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: "#d3a035", animationDelay: "0ms" }} />
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: "#d3a035", animationDelay: "150ms" }} />
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: "#d3a035", animationDelay: "300ms" }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
